import classNames from "classnames";
import moment from "moment";
import React from "react";
import { formatTime, is24Hour, newLineToBr } from "../utilities";
import { PhosphorPencilButton, PhosphorTrashButton } from "components/Atoms/PhosphorIconButton";

interface Props {
  canModify: boolean
  row: server.dto.TimetableEntry
  onDeleteClicked: (id: number) => void
  onEditClicked: (showId: number) => void

  noEndTimes: boolean
  noStartTimes: boolean
}

export default (props: Props) => {
  const onEdit = () => { props.onEditClicked(props.row.timetableEntryId); };
  const onDelete = () => { props.onDeleteClicked(props.row.timetableEntryId); };

  let text;

  if (props.row.type.value === "custom") {
    text = props.row.type.text;
  } else {
    const timetableElementType = serverReference.timetableEntryTypes.find(c => c.value === props.row.type.value);
    text = timetableElementType?.text || "";
  }
  const startTime = props.row.startTime ? formatTime(moment.utc(props.row.startTime)) : "";
  const endTime = props.row.endTime ? formatTime(moment.utc(props.row.endTime)) : "";

  const timeColumnWidth = is24Hour() ? 48 : 78;
  const startTimeClasses = classNames({
    "margin-right": props.noEndTimes
  });
  const underlineStyle: React.CSSProperties = props.row.nextDay ? { textDecoration: "underline" } : {};

  return <div className="flex gap">
    {!props.noStartTimes && (
      <div className={startTimeClasses} style={{ ...underlineStyle, width: timeColumnWidth, whiteSpace: "nowrap" }}>
        <h3>{startTime}</h3>
      </div>)}
    {!props.noEndTimes && <>
      <div style={{ width: 10 }}><h3>{props.row.endTime && "-"}</h3></div>
      <div style={{ width: timeColumnWidth, whiteSpace: "nowrap" }} className="margin-right"><h3>{endTime}</h3></div>
    </>}
    <div className="grow1">
      <div className="margin-bottom-small"><h3>{text}</h3></div>
      <div style={{ wordBreak: "break-word" }}>{newLineToBr(props.row.notes)}</div>
    </div>
    {props.canModify && <>
      <PhosphorTrashButton
        layout="in-square"
        onClick={onDelete}
      />
      <PhosphorPencilButton
        layout="in-square"
        onClick={onEdit}
      />
    </>}
  </div>;
};
